import { getMessaging, getToken } from "firebase/messaging";
import { initializeApp } from "firebase/app";
import { baseUrl } from "../apiConstants";
import Swal from "sweetalert2";
import "../App.css";

const firebaseConfig = {
	apiKey: "AIzaSyCC0CHU1WqjzC1gD0kGpoKKoEOBEJf4fEI",
	authDomain: "redimit-push-test.firebaseapp.com",
	projectId: "redimit-push-test",
	storageBucket: "redimit-push-test.appspot.com",
	messagingSenderId: "681027563945",
	appId: "1:681027563945:web:cfba558e05c50550fb14b8",
	measurementId: "G-CNPNSY608D",
};

/* const app =  */ initializeApp(firebaseConfig);
const messaging = getMessaging();

async function sendToken(url, theToken) {
	try {
		const response = await fetch(url, {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
			},
			redirect: "follow",
			body: JSON.stringify(theToken),
		});
		return response.json();
	} catch (error) {
		// console.error(error, "the error");
	}
}

export const requestPermission = () => {
	if (window.location.pathname === "/") {
		if (!("Notification" in window)) {
			console.error("This browser does not support desktop notification");
		} else if (Notification.permission === "granted") {
			//   Do nothing
		} else if (Notification.permission !== "denied" || Notification.permission === "default") {
			Swal.fire({
				title: "Do you want to receive important updates and information from us? Then click yes and allow push notifications on the next popup",
				showConfirmButton: true,
				confirmButtonText: "Yes!",
				showDenyButton: true,
				denyButtonText: "Not now",
				showClass: {
					popup: `animation-fading-in`,
				},
				hideClass: {
					popup: `animation-fading-out`,
				},
				showCloseButton: true,
				customClass: {
					container: "push-notification-popup-container",
					popup: "push-notification-popup",
					title: "push-notification-popup-title",
					actions: "push-notification-popup-actions",
					confirmButton: "push-notification-popup-confirm-btn",
					denyButton: "push-notification-popup-deny-btn",
					closeButton: "push-notification-popup-close-btn",
				},
			}).then((result) => {
				if (result.isConfirmed) {
					Notification.requestPermission().then(function (permission) {
						if (permission === "granted") {
							getFirebaseToken();
						}
					});
				} else if (result.isDenied) {
				}
			});
		}
	}
};

export const getFirebaseToken = async () => {
	getToken(messaging, { vapidKey: "BBaz_20FGQ8yZ-6kXmZzcNFF6xjXHsspt44D9AWIdP73fbD_0psDAIfHBC6rbWWqapiZBR-pmHKsx0WUhtWWm4E" })
		.then((currentToken) => {
			if (currentToken) {
				sessionStorage.setItem("fbToken", JSON.stringify(currentToken));
				sendToken(`${baseUrl}notifications/subscribe`, { token: currentToken }).then((data) => {
				});
			} else {
				requestPermission();
			}
		})
		.catch((err) => {
			// console.error("An error occurred while retrieving token. Requesting permission to generate another one...", err);
			requestPermission();
		});
};
